import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Icon from '../elements/Icon';
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'
export default class ButtonDropdown extends Component {
  dropdown;
  triggerBtn;

  componentDidMount() {
    document.addEventListener('mousedown', this._handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this._handleClickOutside);
  }

  render() {

    const {textStyle, triggerText, triggerIcon, dropdownFromRight, dropdownStyled, dropdownHeightLimited, extraClasses, expanded, title, children} = this.props;

    const classes = classNames({
      'state-expanded': expanded
    })

    const extras = extraClasses ? extraClasses : '';

    const buttonStyles = textStyle ? 'button-dropdown__trigger-text' : 'button-dropdown__trigger';
    const isTrigger = buttonStyles ==='button-dropdown__trigger';

    return (
      <span className={`button-dropdown hide-for-no-js ${classes || ''} ${extras || ''}`} 
            ref={e => (this.dropdown = e)}>
        {getStyleTag([
          'button-dropdown__trigger', 
          'button-dropdown', 
          'button-dropdown__trigger-text'
        ])}
        <button
          ref={e => (this.triggerBtn = e)}
          className={buttonStyles}
          style={isTrigger ? 
            getStyles('button-dropdown__trigger') : 
            getStyles('button-dropdown__trigger-text')}
          aria-haspopup="true"
          title={title}
          onClick={this._handleClick}
          >
            {triggerText && <span>{triggerText}</span>}
            {triggerIcon && <Icon icon={triggerIcon} aria-hidden />}
          </button>

        <div
          className={classNames(
          "button-dropdown__dropdown",
          {"button-dropdown__dropdown--styled" : dropdownStyled},
          {"button-dropdown__dropdown--right" : dropdownFromRight},
          {"button-dropdown__dropdown--height-limited" : dropdownHeightLimited}
          )}
          aria-expanded={expanded ? "true" : "false"}
          aria-hidden={expanded ? "false" : "true"}
        >
          {children}
        </div>
      </span>
    );
  };

  _handleClick = (e) => {
     this.props.handleClick(e);
  }

  _handleClickOutside = ({target}) => {
    if (
      this.dropdown &&
      !this.dropdown.contains(target) &&
      this.triggerBtn &&
      this.props.expanded
    ) {
      this.triggerBtn.click();
    }
  };

}

ButtonDropdown.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string,
  expanded: PropTypes.bool,
  textStyle: PropTypes.bool,
  dropdownStyled: PropTypes.bool,
  dropdownHeightLimited: PropTypes.bool,
  extraClasses: PropTypes.string,
  triggerText: PropTypes.string,
  triggerIcon: PropTypes.string
}

ButtonDropdown.defaultProps = {
  expanded: false,
  textStyle: false,
  triggerText: '',
  triggerIcon: '',
  dropdownStyled: false,
  dropdownHeightLimited: false
};



// WEBPACK FOOTER //
// ./webapp/components/elements/ButtonDropdown.js